module.exports = __webpack_public_path__ + "static/media/icono_harina.db3089b0.png";